import { render, staticRenderFns } from "./validationText.vue?vue&type=template&id=23949bb3&scoped=true&"
import script from "./validationText.vue?vue&type=script&lang=js&"
export * from "./validationText.vue?vue&type=script&lang=js&"
import style0 from "./validationText.vue?vue&type=style&index=0&id=23949bb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23949bb3",
  null
  
)

export default component.exports